export class QuadraListDto {
  id: number;
  label: string;
  lotesQuantidade: number;
  coords: number[][];

  constructor(
    id: number,
    label: string,
    lotesQuantidade: number,
    coords: number[][]
  ) {
    this.id = id;
    this.label = label;
    this.lotesQuantidade = lotesQuantidade;
    this.coords = coords;
  }
}
